import type { Link } from '@frontend/libs/types/common'
import type { Image } from '@frontend/libs/types/media'
import type { Product } from '@frontend/libs/types/product'

export type filters = {
  slug: string
  terms: term[]
  title: string
}[]

export type term = {
  count: number
  id: number
  name: string
  slug: string
}

export type Pagination = {
  limit: number
  page: number
  pageCount: number
  total: number
}

export enum Sort {
  Date = 'date',
  Default = 'default',
  Popularity = 'popularity',
  Price = 'price',
  PriceDesc = 'price-desc',
}

export type ProductListResponse = {
  content: null | string
  data: Product[]
  featuredImage: Image | null
  featuredType: 'image' | 'video'
  featuredVideo: null | string
  filters: filters
  lookBooks: LookBook[]
  pagination: Pagination
}

export type LookBook = {
  gallery: Image[]
  id: string
  link: Link
  title: string
}
